import React, { useContext } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import useMount from 'ggApp/shared/hooks/useMount';

import {
    isIncompletePrivateAccount as isIncompletePrivateAccountSelector,
    isIncompleteBusinessAccount as isIncompleteBusinessAccountSelector,
    isLegacyBusinessAccount as isLegacyBusinessAccountSelector,
    isLoggedIn as isLoggedInSelector,
    b2bRedirection as b2bRedirectionSelector,
    authFlow as authFlowSelector,
} from 'ggApp/modules/auth/selectors';
import { newCheckoutVariants } from 'ggApp/modules/featureFlag/constants';
import flows from 'ggApp/modules/newCheckout/flows';
import { translate, keys as translationsSelector } from 'ggApp/modules/translator/selectors';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import { SinglePageCheckout } from 'ggApp/modules/newCheckout/components/SinglePageCheckout';
import { redirectus as redirectAction } from 'ggApp/modules/router/actions';
import { locationQuery as locationQuerySelector } from 'ggApp/modules/router/selectors';
import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';

import withWebView from 'ggApp/shared/hocs/withWebView';
import MetaTagsContainer from 'ggApp/shared/containers/metaTags';
import { Layout, Content, StyledLogo, Background } from 'ggApp/shared/screens/Auth/Auth.styles';
import Footer from 'ggApp/shared/screens/Auth/Footer/Footer';

import { blockManagedAccountCheckoutEnabled } from 'ggApp/modules/featureFlag';
import { NewCheckoutModalWrap } from './styled';

const FooterWithChecker = withWebView(Footer);

const NewCheckoutScreen = ({
    isLoggedIn,
    translations,
    storeActive,
    isIncompletePrivateAccount,
    isIncompleteBusinessAccount,
    isLegacyBusinessAccount,
    isBlockManagedAccountCheckout,
    redirect,
    locationQuery,
    b2bRedirection,
    initialAuthFlow,
}) => {
    const metaPageInfo = {
        title: translate(translations, storeActive.activeLanguage, 'CHECKOUT_META_TITLE'),
    };

    const { send, newCheckoutFlag } = useContext(OrderContext);

    const newCheckoutFlow = () => {
        if (newCheckoutFlag && newCheckoutFlag.variantKey === newCheckoutVariants.withHomeAddress) {
            return flows.CHECKOUT_WITH_HOME_ADDRESS;
        }
        return flows.CHECKOUT_NO_HOME_ADDRESS;
    };

    useMount(() => {
        send('FETCH_ORDER');
    });

    return (
        <div data-testid="new-checkout-screen">
            <Layout>
                <MetaTagsContainer metaTags={{ metaPageInfo }} />
                <Background />
                <Content>
                    <StyledLogo />
                    <NewCheckoutModalWrap>
                        <SinglePageCheckout
                            checkoutFlow={newCheckoutFlow}
                            isLoggedIn={isLoggedIn}
                            isIncompletePrivateAccount={isIncompletePrivateAccount}
                            isIncompleteBusinessAccount={isIncompleteBusinessAccount}
                            isLegacyBusinessAccount={isLegacyBusinessAccount}
                            isBlockManagedAccountCheckout={isBlockManagedAccountCheckout}
                            redirect={redirect}
                            storeActive={storeActive}
                            locationQuery={locationQuery}
                            b2bRedirection={b2bRedirection}
                            initialAuthFlow={initialAuthFlow}
                        />
                    </NewCheckoutModalWrap>
                    <FooterWithChecker
                        storeCode={storeActive.code}
                        activeLanguage={storeActive.activeLanguage}
                    />
                </Content>
            </Layout>
        </div>
    );
};

const enhance = compose(
    connect(
        createStructuredSelector({
            isLoggedIn: isLoggedInSelector,
            translations: translationsSelector,
            storeActive: activeStoreSelector,
            isIncompletePrivateAccount: isIncompletePrivateAccountSelector,
            isIncompleteBusinessAccount: isIncompleteBusinessAccountSelector,
            isLegacyBusinessAccount: isLegacyBusinessAccountSelector,
            isBlockManagedAccountCheckout: blockManagedAccountCheckoutEnabled,
            locationQuery: locationQuerySelector,
            b2bRedirection: b2bRedirectionSelector,
            initialAuthFlow: authFlowSelector,
        }),
        (dispatch) => ({
            redirect: bindActionCreators(redirectAction, dispatch),
        }),
    ),
);
export default enhance(NewCheckoutScreen);
